import { Link } from 'react-router-dom';
import { solutions } from '@/mocks/data';

function SolutionCard({ solution }: { solution: typeof solutions[number] }) {
  if (solution.id === 'yingyang') {
    return (
      <Link
        to="/category?tab=yingyang"
        className="group bg-background-50 rounded-2xl border border-primary-200/60 p-6 transition-all hover:border-primary-300 hover:shadow-sm cursor-pointer"
      >
        <div className="relative w-full h-48 rounded-xl overflow-hidden mb-5">
          <img
            src={solution.image}
            alt={solution.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
          <div className="w-1.5 h-1.5 rounded-full bg-primary-500"></div>
          {solution.title}
        </div>
        <h3 className="font-heading text-lg text-foreground-900 mb-2">{solution.subtitle}</h3>
        <p className="text-foreground-600 text-sm leading-relaxed mb-4">{solution.description}</p>
        <div className="flex flex-wrap gap-1.5">
          {solution.features.map((f, i) => (
            <span key={i} className="px-2.5 py-1 bg-primary-50 rounded-full text-xs text-primary-700">
              {f}
            </span>
          ))}
        </div>
      </Link>
    );
  }

  if (solution.id === 'zaojiao') {
    return (
      <Link
        to="/category?tab=zaojiao"
        className="group bg-background-50 rounded-2xl border border-accent-200/60 p-6 transition-all hover:border-accent-300 hover:shadow-sm cursor-pointer"
      >
        <div className="relative w-full h-48 rounded-xl overflow-hidden mb-5">
          <img
            src={solution.image}
            alt={solution.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
          <div className="w-1.5 h-1.5 rounded-full bg-accent-500"></div>
          {solution.title}
        </div>
        <h3 className="font-heading text-lg text-foreground-900 mb-2">{solution.subtitle}</h3>
        <p className="text-foreground-600 text-sm leading-relaxed mb-4">{solution.description}</p>
        <div className="flex flex-wrap gap-1.5">
          {solution.features.map((f, i) => (
            <span key={i} className="px-2.5 py-1 bg-accent-50 rounded-full text-xs text-accent-700">
              {f}
            </span>
          ))}
        </div>
      </Link>
    );
  }

  return (
    <Link
      to="/category?tab=xiguan"
      className="group bg-background-50 rounded-2xl border border-secondary-200/60 p-6 transition-all hover:border-secondary-300 hover:shadow-sm cursor-pointer"
    >
      <div className="relative w-full h-48 rounded-xl overflow-hidden mb-5">
        <img
          src={solution.image}
          alt={solution.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
        <div className="w-1.5 h-1.5 rounded-full bg-secondary-500"></div>
        {solution.title}
      </div>
      <h3 className="font-heading text-lg text-foreground-900 mb-2">{solution.subtitle}</h3>
      <p className="text-foreground-600 text-sm leading-relaxed mb-4">{solution.description}</p>
      <div className="flex flex-wrap gap-1.5">
        {solution.features.map((f, i) => (
          <span key={i} className="px-2.5 py-1 bg-secondary-50 rounded-full text-xs text-secondary-700">
            {f}
          </span>
        ))}
      </div>
    </Link>
  );
}

export default function SolutionsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            核心方案
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            三大成长方案，一站式陪伴
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            科学系统的方法，让每个3岁宝宝在营养、早教、习惯三方面全面发展
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {solutions.map((solution) => (
            <SolutionCard key={solution.id} solution={solution} />
          ))}
        </div>
      </div>
    </section>
  );
}